import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import {
  Box,
  Link,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { Row } from "react-bootstrap";
import { Timer2Bold } from "../../../../Icon";
import EGDatePicker from "../../../../MainComponents/DatePicker/EGDatePicker";
import { EGIconButton } from "../../../../MainComponents/Button/IconButton/IconButton";
import { parseDateToDDMMYYYY2, parseDateToLgComun } from "../../../../../helpers/dateTransform";
import { HelpIcon } from "../../../../MainComponents/HelpIcon/HelpIcon";

export const DeadlineForConclusion = ({
  dateDeadLine,
  deadLineDetails,
  setDeadLineDetails,
  conclusionDeadline,
  setConclusionDeadline,
  reportDetail,
  editing,
  loading,
  details,
  setDetails,
  editIndicator,
  saveIndicatorInfo,
  openModalAction,
}) => {
  const [t] = useTranslation("information");
  const theme = useTheme();

  return (
    <Row
      className={`conclusionDeadline rounded dyTheme1 dyBorder1 mt-20 px-[8] py-[20]`}
    >
      <Box display="flex" justifyContent="space-between">
        <Stack
          display="flex"
          direction="row"
          justifyContent="start"
          alignItems="center"
          spacing={1}
          sx={{ overflow: "hidden" }}
          flexGrow={1}
        >
          <Box sx={{ height: 24, width: 24 }}>
            <Timer2Bold color={`${theme.palette.blue.main}`} />
          </Box>

          {editing.schedule ? (
            <Box marginTop={1} flexGrow={1}>
              <EGDatePicker
                label={`${t("information.completion_deadline")}`}
                value={conclusionDeadline}
                onChange={(newDate) => setConclusionDeadline(newDate)}
                minDate={dayjs(reportDetail.created_at)}
                className="date-picker-deadline"
                format="DD/MMM/YYYY"
              />
            </Box>
          ) : (
            <Box display="flex" alignItems="center">
              <div>
                <Typography
                  style={{ display: "inline" }}
                  color={"blueGray700"}
                  component="p"
                  fontSize={15}
                  fontWeight={600}
                >
                  {t("information.completion_deadline")}: &nbsp;
                  <b
                    style={{
                      color: theme.palette.blue.main,
                      wordWrap: "normal",
                    }}
                  >{`${
                    reportDetail?.custom_dates?.end_day
                      ? parseDateToLgComun(
                          dayjs(reportDetail?.custom_dates.end_day)
                        )
                      : parseDateToLgComun(dateDeadLine.toDateString())
                  }`}</b>
                </Typography>
                <div style={{ display: "inline" }}>
                  <HelpIcon
                    text={t("information.help_icon_deadline")}
                    className="mx-[5] d-inline-block"
                  />
                </div>
              </div>
            </Box>
          )}
        </Stack>
        <Stack
          direction="row"
          display="flex"
          alignItems="center"
          justifyContent="end"
          spacing={0.5}
          marginLeft={2}
        >
          {editing.schedule && (
            <EGIconButton
              disabled={loading.schedule}
              iconName="check_icon"
              title={t("information.save")}
              placement="bottom"
              color="success"
              iconColor="white"
              onClick={() =>
                openModalAction(
                  () => saveIndicatorInfo("schedule"),
                  t("information.deadline_modification"),
                  t(
                    "information.changing_conclusion_date_affects_all_involved_users"
                  ),
                  t(
                    "information.its_essential_notify_this_change_ensure_that_everyone_informed"
                  ),
                  t("information.are_you_sure_you_want_continue")
                )
              }
              sx={{ height: 24, width: 24, padding: 0 }}
            />
          )}
          <EGIconButton
            disabled={loading.schedule}
            iconName={`${editing.schedule ? "close_icon" : "outline_edit"}`}
            iconColor={!editing.schedule ? "secondary" : ""}
            color={`${editing.schedule ? "error" : ""}`}
            title={
              editing.schedule ? t("information.cancel") : t("information.edit")
            }
            placement="bottom"
            onClick={() => editIndicator("schedule")}
            iconSize={editing.schedule ? 23 : 16}
            sx={{ height: 24, width: 24, padding: 0 }}
          />
        </Stack>
      </Box>
    </Row>
  );
};
